import { apiCall } from "../helper/Common";

export async function fetchShopSettings() {
  const res = await apiCall("shop-settings", "GET");
  if (!res?.success) throw new Error(res?.message || "Failed to load settings");
  return res.data?.settings;
}

export async function saveShopSettings(settings) {
  const res = await apiCall("shop-settings", "PUT", settings);
  if (!res?.success) throw new Error(res?.message || "Failed to save settings");
  return res.data;
}
